/*
 * @Author: your name
 * @Date: 2021-01-03 19:57:03
 * @LastEditTime: 2021-01-27 16:26:10
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/vender/form-schema-config/components/form-orc-input.config.js
 */
import Vue from 'vue'
import apis from '../../../api/index'
import axios from 'axios'

const FormOrcInputConfig = {
  // 类型
  componentType: 'FORM_OCR_IDENTIFY',
  // 部件显示样式
  widgetConfig: {
    icon: 'form-orc',
    text: '字符识别',
    optionTitle: true,
    description: '用于自动识别特定场景中文件包含的字符'
  },
  componentConfig: {
    uuid: `32bit uuid`,
    width: 6, // 3, 6, 9, 12
    height: 1,
    render: {
      ide: 'FormOrcInput',
      edit: 'FormOrcInput',
      read: 'FormOrcInput'
    },
    label: '字符识别',
    enableRule: false,
    abort: null,
    methods: {
      lcInitData: {
        edit: (...args) => {
          console.log(args)
        }
      },
      lcUploadFile: function(...args) {
        let data = args[args.length - 1]
        let formData = new FormData()
        formData.append('file', data.data, data.data.name)
        formData.append('formId', data.globalData.formId)
        formData.append('componentId', data.componentId)
        return new Promise((resolve, reject) => {
          const request = { ...apis.COMPONENT.FORM_ORC_UPLOAD_API }
          request.params = formData
          const CancelToken = axios.CancelToken
          const that = this
          request.cancelToken = new CancelToken(function executor(c) {
            that.widget.abort = c
          })
          Vue.prototype
            .$upload(request)
            .asyncThen(
              (resp) => {
                resolve(resp)
              },
              (err) => {
                Vue.prototype.$message({
                  message: err.message,
                  type: 'error'
                })
                reject(err)
              }
            )
            .asyncErrorCatch((err) => {
              reject(err)
            })
        })
      },
      lcUploadFileInWx: function(...args) {
        let data = args[args.length - 1]
        let params = {
          file: data.file,
          formId: data.globalData.formId,
          componentId: data.componentId
        }
        return new Promise((resolve, reject) => {
          const request = { ...apis.COMPONENT.FORM_ORC_UPLOAD_WX_API }
          request.params = params
          request.timeout = 100000
          const CancelToken = axios.CancelToken
          const that = this
          request.cancelToken = new CancelToken(function executor(c) {
            that.widget.abort = c
          })
          Vue.prototype
            .$request(request)
            .asyncThen(
              (resp) => {
                resolve(resp)
              },
              (err) => {
                Vue.prototype.$message({
                  message: err.message,
                  type: 'error'
                })
                reject(err)
              }
            )
            .asyncErrorCatch((err) => {
              reject(err)
            })
        })
      },

      lcRemoveUpload(...args) {
        let file = args[args.length - 1]
        return new Promise((resolve, reject) => {
          const request = { ...apis.COMPONENT.FORM_UPLOAD_CONFIG_DELETE }
          request.params = {
            file: file.id
          }
          Vue.prototype.$request(request).asyncThen((resp) => {
            resolve(resp)
          }, (err) => {
            reject(err)
          }).asyncErrorCatch((err) => {
            reject(err)
          })
        })
      }
    },
    inTable: true
  },
  methods: {},
  editorConfig: [
    'INFO',
    'LABEL',
    'ORC_TYPE',
    'ORC_SELECTOR',
    'WIDTH',
    'HIDDEN',
    'READONLY',
    'REQUIRED',
    'EDITONNEW'
  ],
  excludeEditorConfigInTable: ['WIDTH']
}

export default FormOrcInputConfig
